import { ProgressKind, RequestKind, boolean, string } from '@sb/library/base';
import { BatchResultItem, BatchTeacherAvailabilityItems, DisplayItemCollection, TeacherAvailabilityDisplayItem, TeacherAvailabilityInputItem, TeacherAvailabilitySearchOptions, TeacherAvailabilityUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace TeacherAvailabilityRoutes {
    export const Add = ApiRoute.Define({
        URL: `teacheravailabilities`,
        Kind: RequestKind.Post,
        BodyType: TeacherAvailabilityInputItem,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (teacherAvailabilityID: string) => `teacheravailabilities/${teacherAvailabilityID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (teacherAvailabilityID: string) => `teacheravailabilities/${teacherAvailabilityID}`,
        Kind: RequestKind.Get,
        ResultType: TeacherAvailabilityDisplayItem
    });

    export const Search = ApiRoute.Define({
        URL: `search/teacheravailabilities`,
        Kind: RequestKind.Post,
        BodyType: TeacherAvailabilitySearchOptions,
        ResultType: DisplayItemCollection<TeacherAvailabilityDisplayItem>
    });

    export const Update = ApiRoute.Define({
        URL: (teacherAvailabilityID: string) => `teacheravailabilities/${teacherAvailabilityID}`,
        Kind: RequestKind.Put,
        BodyType: TeacherAvailabilityUpdateItem,
        ResultType: boolean
    });
    
    export const BatchUpdate = ApiRoute.Define({
        URL: 'teacheravailabilities',
        Kind: RequestKind.Patch,
        BodyType: BatchTeacherAvailabilityItems,
        ResultType: Array<BatchResultItem<boolean, never>>,
        ShowProgress: ProgressKind.Computation
    });
}
